export default __webpack_public_path__ + "static/media/conversion-rate-optimazation.6f59d4d4.png";